import * as React from 'react';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import {
    Box,
    Button,
    FormControl,
    Grid,
    TextField,
    Select,
    Tooltip,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import MenuItem from '@mui/material/MenuItem';
import { makeStyles } from "@mui/styles";
import { useState } from 'react';

const useStyles = makeStyles((theme) => ({
    addButton: {
        position: "absolute",
        right: 30,
        top: 135,
        zIndex: 99,
    },
}))

const StyledTextField = styled(TextField)(({ theme }) => ({
    "& input": {
        padding: "10px 10px !important",
        height: '0.4375em',
    },
    // ".muiltr-rboi0c-MuiInputBase-root-MuiOutlinedInput-root": {
    //     lineHeight: 1,
    //     minHeight: '30px',
    // },
    "& .MuiInputBase-root": {
        fontSize: "12px",
        fontWeight: 600,
        lineHeight: 3,
        minHeight: '30px',
        border: "1px solid #FAA2204D",
        borderRadius: "5px",
    },
}));

const StyledSelect = styled(Select)(({ theme }) => ({
    "& input": {
        padding: "10px 15px !important",
        height: "0.4375em",
    },
    "&.MuiInputBase-root": {
        fontSize: "12px",
        fontWeight: 500,
        lineHeight: 3,
        minHeight: '30px',
        border: "1px solid #FAA2204D",
        borderRadius: "5px",
    }
}
))

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // bgcolor: 'background.paper',
    bgcolor: '#212529',
    borderRadius: '9.23px',
    // border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

export default function RequestForm(props) {
    const [open, setOpen] = React.useState(props.showRequestForm);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const [selectedTrainingDate, setSelectedTrainingDate] = useState("")
    const [selectedPartner, setSelectedPartner] = useState("")
    const [selectedTrainingMode, setSelectedTrainingMode] = useState("")
    const [selectedTrainingLocation, setSelectedTrainingLocation] = useState("")
    const [noOfAttendees, setNoOfAttendees] = useState("")
    const [selectedLevelOfTrainees, setSelectedLevelOfTrainees] = useState("")
    const [name, setName] = useState("")
    const [selectedJobTitle, setSelectedJobTitle] = useState("")
    const [selectedTrainingCourse, setSelectedTrainingCourse] = useState("");
    const [subject, setSubject] = useState("")
    const [reason, setReason] = useState("")
    const [selectedPreferredOne, setSelectedPreferredOne] = useState("")
    const [selectedPreferredTwo, setSelectedPreferredTwo] = useState("")
    const [selectedPreferredThree, setSelectedPreferredThree] = useState("")

    const viewPartner = ["House one", "House two"];
    const viewTrainingMode = ["Online", "Physical"];
    const viewTrainingLocation = ["UAE", "MALDIVES", "KUWAIT"];
    const viewLevelTrainee = ["Level one", "Level two"];
    const viewJobTitle = ["Software", "Product Engineer"];
    const viewTrainingCourse = ["Software", "Operation"];
    const viewPreferred = ["Salam", "Chona", "Sujith", "Osnur"];

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <h3>Training Request</h3>
                <FormControl className="flex flex-row mt-8">
                    <div className='grid grid-cols-3 gap-12'>
                        <div>
                            <label>Training Date</label>
                            <StyledTextField type="date" variant="outlined" fullWidth name="company" value={selectedTrainingDate}
                                onChange={(e) => { setSelectedTrainingDate(e.target.value) }} />
                        </div>
                        <div>
                            <label>Partner</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedPartner}
                                name="viewOptions"
                                onChange={(e) => { setSelectedPartner(e.target.value) }}
                                variant="outlined"
                            >
                                {viewPartner
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Training Mode</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedTrainingMode}
                                name="viewOptions"
                                onChange={(e) => { setSelectedTrainingMode(e.target.value) }}
                                variant="outlined"
                            >
                                {viewTrainingMode
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Training Location</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedTrainingLocation}
                                name="viewOptions"
                                onChange={(e) => { setSelectedTrainingLocation(e.target.value) }}
                                variant="outlined"
                            >
                                {viewTrainingLocation
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Number of Attendees</label>
                            <StyledTextField type="number" variant="outlined" fullWidth name="loadingDate" value={noOfAttendees}
                                onChange={(e) => { setNoOfAttendees(e.target.value) }}
                            />
                        </div>
                        <div>
                            <label>Level of Trainees</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedLevelOfTrainees}
                                name="viewOptions"
                                onChange={(e) => { setSelectedLevelOfTrainees(e.target.value) }}
                                variant="outlined"
                            >
                                {viewLevelTrainee
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Name of Trainee</label>
                            <StyledTextField type="text" variant="outlined" fullWidth name="teritory" value={name}
                                onChange={(e) => { setName(e.target.value) }} />
                        </div>
                        <div>
                            <label>Job Title</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedJobTitle}
                                name="viewOptions"
                                onChange={(e) => { setSelectedJobTitle(e.target.value) }}
                                variant="outlined"
                            >
                                {viewJobTitle
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Training Course</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedTrainingCourse}
                                name="viewOptions"
                                onChange={(e) => { setSelectedTrainingCourse(e.target.value) }}
                                variant="outlined"
                            >
                                {viewTrainingCourse
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Subject</label>
                            <StyledTextField type="text" variant="outlined" fullWidth name="commisionName" value={subject}
                                onChange={(e) => { setSubject(e.target.value) }} />
                        </div>
                        <div className='col-span-2'>
                            <label>Reason for Request</label>
                            <StyledTextField type="textarea" variant="outlined" fullWidth name="commisionName" value={reason}
                                onChange={(e) => { setReason(e.target.value) }} />
                        </div>
                        <div>
                            <label>Preferred Trainer1</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedPreferredOne}
                                name="viewOptions"
                                onChange={(e) => { setSelectedPreferredOne(e.target.value) }}
                                variant="outlined"
                            >
                                {viewPreferred
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Preferred Trainer2</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedPreferredTwo}
                                name="viewOptions"
                                onChange={(e) => { setSelectedPreferredTwo(e.target.value) }}
                                variant="outlined"
                            >
                                {viewPreferred
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                        <div>
                            <label>Preferred Trainer3</label>
                            <StyledSelect
                                className="w-full rounded-8 h-2.5 overflow-hidden"
                                value={selectedPreferredThree}
                                name="viewOptions"
                                onChange={(e) => { setSelectedPreferredThree(e.target.value) }}
                                variant="outlined"
                            >
                                {viewPreferred
                                    .map((val, index) => (
                                        <MenuItem
                                            key={val}
                                            value={val}
                                            className="m-8 mt-0 rounded-lg"
                                        >
                                            {val}
                                        </MenuItem>
                                    ))}
                            </StyledSelect>
                        </div>
                    </div>
                </FormControl>
                <div className='grid grid-cols-2'>
                    <div className='row-start-4 col-start-1'>
                        <Button color="primary" variant="outlined" >Cancel</Button>
                    </div>
                    <div className='row-start-4 col-start-2'>
                        <Button color="primary" variant="outlined" >Request Training</Button>
                    </div>
                </div>
            </Box>
        </Modal>
    )
}
